import { Panel } from '@/components/Layouts/ContentPanel';
import OrganizationsPanel from '@/components/Organizations/OrganizationsPanel';
import { OrgContextProvider } from '@/components/Organizations/OrgContext';
import config from '@/config';
import { useAuth } from '@/providers/AuthProvider';
import { Link, useParams } from 'react-router-dom';

function Admin() {
  const { groups, tenant } = useAuth();
  const { tenantId } = useParams();

  const isPeaceLoveAdmin = groups.includes(config.admin.superAdminGroup);

  const actualTenantId = tenantId ?? (tenant as string);
  const includeOrgs = isPeaceLoveAdmin && !tenantId;

  if (!actualTenantId) {
    return null;
  }

  return (
    <>
      <OrgContextProvider>
        <div className="overflow-auto h-full">
          <div className="w-900 mx-auto content-wrapper">
            <Panel
              title="Game"
              headerChildren={
                <div className="flex gap-[16px]">
                  {isPeaceLoveAdmin && (
                    <Link className="btn btn-primary" to="/dashboard/gamepacks">
                      Manage Game Packs and Prompts
                    </Link>
                  )}
                </div>
              }
            />
            {includeOrgs && isPeaceLoveAdmin && (
              <div className="mt-32">
                <OrganizationsPanel />
              </div>
            )}
          </div>
        </div>
      </OrgContextProvider>
    </>
  );
}

export default Admin;
